import PagesMaintenance from "pages/Utility/pages-maintenance";

const DriverTopup = () => {
  return (
    <PagesMaintenance />
  );
};

export default DriverTopup;
